const FintechNotHiredI18n = {
  title: {
    contractValidationError: 'Não foi possível realizar a validação do contrato!',
    productNotHired: 'Você ainda não contratou {{ serviceName }}.',
    wishToHire: 'Quero contratar',
    sasNotFoundClientInformations: 'Não foi possivel obter as informações de licença',
    notInBeta: 'Funcionalidade em fase de testes',    
    clickHere: 'Clique aqui',
  },
  service: {
    BOLETO_RAPIDO: 'Boleto Rápido',
    PIX: 'Pix Imediato',
    PAGAMENTO: 'Pagamentos',
    DDA: 'DDA',
    SCORE: 'Sankhya Score',
  },
  message: {
    contractValidationUnexpectedError: 'Durante o processo de validação foi encontrado um problema inesperado. Aguarde alguns minutos, caso persista, acione a equipe de suporte.',
    contractValidationError: 'Durante o processo de validação foi encontrado o seguinte erro: ',
    serviceNotIncludedInCurrentPack: 'O pacote de serviços atualmente contratado "{{ package }}" não contempla o serviço de "{{ serviceName }}".',
    clickHereToContractPackage: '{{ hireButton }} para realizar a contratação de um pacote que inclua esse serviço.',
    availableOnlyWhenBankSlipHired: 'Essa configuração só está disponível pra quem já contratou o Boleto Rápido.',
    simpleOperationsWhenBankSlipHired: 'Com ele, você pode emitir boletos de forma simples e integrada ao seu ERP.',
    availableOnlyWhenPixHired: 'Essa configuração só está disponível pra quem já contratou o Pix Imediato.',
    simpleOperationsWhenPixHired: 'Com ele, você pode realizar recebimentos de forma simples e integrada ao seu ERP.',
    availableOnlyWhenPaymentsHired: 'Essa configuração só está disponível pra quem já contratou o serviço de Pagamentos.',
    simpleOperationsWhenPaymentsHired: 'Com ele, você pode automatizar o seu fluxo de pagamentos de forma simples e integrada ao seu ERP.',
    sasNotFoundClientInformations:
      'Para validar a contratação dos serviços de Fintech é necessário ter o servidor de licença ativo, verifique sua licença e o status de conexão com servidor de licença.',
    notInBetaDescription:
      'Esta funcionalidade está em fase de testes (Beta) com um grupo limitado de clientes e será liberada para todos em breve. Caso tenha interesse em ser um Beta desta funcionalidade, entre em contato com o seu Gerente de Relacionamentos.',
  },
};

export default FintechNotHiredI18n;
